import { render, staticRenderFns } from "./OtherExpenses.vue?vue&type=template&id=5670aef0&scoped=true&"
import script from "./OtherExpenses.vue?vue&type=script&lang=js&"
export * from "./OtherExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670aef0",
  null
  
)

export default component.exports